<template>
  <div class="dropdown-select" :class="{ 'no-border': !bordered }">
    <treeselect
      :value="selectedValue"
      :options="treeselectOptions"
      :placeholder="placeholder"
      :clearable="clearable"
      :disabled="disabled"
      :searchable="searchable"
      :noOptionsText="noOptionsText"
      :appendToBody="true"
      :zIndex="60001"
      @input="onInput"
    />
  </div>
</template>

<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  name: "CrewDropdownSelect",
  components: {
    Treeselect,
  },
  props: {
    placeholder: {
      type: String,
      default: "",
    },
    clearable: {
      type: Boolean,
      required: false,
      default: false,
    },
    bordered: {
      type: Boolean,
      required: false,
      default: true,
    },
    onSelect: {
      type: Function,
      required: false,
      default: () => {},
    },
    selectedValue: {
      required: true,
    },
    selectOptions: {
      type: Array,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    searchable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    // selectOptionsをtreeselectの形式に変換
    // { value, text, featherIconName? } -> { id, label }
    treeselectOptions() {
      return this.selectOptions.map(option => ({
        id: option.value,
        label: option.text,
        // featherIconNameはtreeselectでは直接サポートされていないため、
        // 必要に応じてカスタムレンダリングを実装する必要がある
        // 現時点ではlabelのみを使用
      }));
    },
    noOptionsText() {
      return "選択肢なし";
    },
  },
  methods: {
    onInput(value) {
      this.$emit("update:selectedValue", value);
      this.onSelect(value);
    },
  },
};
</script>
